import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import ContactProfileDto from '@/models/Contacts/ContactProfileDto';
import ContactProfileSearchRequest from '@/models/Contacts/ContactProfileSearchRequest';
import ContactSearchViewModel from '@/models/Contacts/ContactSearchViewModel';
import WorkerProfileSearchRequest from '@/models/Workers/WorkerProfileSearchRequest';
import WorkerStatus from '@/models/Workers/WorkerStatus';
import WorkType from '@/models/Shared/WorkType';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import PositionDto from '@/models/Positions/PositionDto';
import LocationTypeDto from '@/models/LocationTypes/LocationTypeDto';
import SelectableEntity from '@/models/Shared/SelectableEntity';
import UserProfileDto from '@/models/Users/UserProfileDto';
import { AgencySettingsModule } from './agencySettings';
import BranchDto from '@/models/Branches/BranchDto';

export interface IContactListState {
  loading: boolean;
  contacts: ContactProfileDto[];
  contactSearchViewModel: ContactSearchViewModel;
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'ContactList', namespaced: true})
class ContactList extends VuexModule implements IContactListState {
  
  public loading = true;
  public contacts: ContactProfileDto[] = [];  
  public contactSearchViewModel: ContactSearchViewModel = new ContactSearchViewModel();
  public loadingDialog = false;

  @Action 
  async mapUserDefaults() {
    const userProfile = AppModule.userProfile;
    this.context.commit("setUserDefaults", userProfile);
  }

  @Action
  async searchContacts() {
    const request = new ContactProfileSearchRequest();
    
    request.status = this.contactSearchViewModel.selectedStatus;
    request.isAgreedToMarketing = this.contactSearchViewModel.isAgreedToMarketing;
    if (this.contactSearchViewModel.selectedPositions.length !== 0) {
      request.positionCodes = this.contactSearchViewModel.selectedPositions.map(function(position: PositionDto) {
        return position.code;
      });
    }

    if (this.contactSearchViewModel.selectedLocationTypes.length !== 0) {
      request.locationTypeIds = this.contactSearchViewModel.selectedLocationTypes.map(function(locationType: LocationTypeDto) {
        return locationType.id;
      });
    }

    if (this.contactSearchViewModel.selectedWorker != null) {
      if (this.contactSearchViewModel.selectedDistance.value !== 0) {
        request.distance = this.contactSearchViewModel.selectedDistance.value;
        request.latitude = this.contactSearchViewModel.selectedWorker.latitude;
        request.longitude = this.contactSearchViewModel.selectedWorker.longitude;
      }
    }

    this.setLoading(true);
    await ajax.post(`/api/v1/agency/contacts/search`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setContacts", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getWorkersForSearchOptions() {
    const request = new WorkerProfileSearchRequest();
    request.statuses.push(WorkerStatus.Active);
    request.workTypes.push(WorkType.Perm);
    //this.setLoading(true);
    await ajax.post(`/api/v1/agency/workers/search`, request)
    .then(response => {
      this.context.commit("setWorkers", response.data);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.loading = true;
    this.contacts = [];
    this.loadingDialog = false;
   
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setContacts(contacts: ContactProfileDto[]) {
    this.contacts = contacts;
    this.contactSearchViewModel.selectedContacts = [];
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setWorkers(workers: WorkerProfileDto[]) {
      this.contactSearchViewModel.workers = workers;
  }

  @Mutation
  private async setUserDefaults(userProfile: UserProfileDto) {
    if (!userProfile.defaultBranchId) {
      return;
    }
    if (AgencySettingsModule.branches.length === 0) {
      return;
    }
   }
}

export const ContactListModule = getModule(ContactList)
